SectionCell = React.createClass
  render: ->
    <td rowSpan={@props.rowSpan}>
      {@props.children}
    </td>

module.exports = SectionCell
